// import { BettingInfoIssueModel } from "./credit.model";

export class LotteryTypeModel {
    LotteryTypeCode: string = "";                        //彩票类别代码
    LotteryTypeName: string = "";                    //彩票类型名称
    OrderId: number = 0;
    Status: number = 0;
    type:string = '';
}


/**
 *
 * 彩种扩展（LotteryExt） 彩种表Lottery的扩展
 * evan 2018-09-18
 */
export class LotteryModel {
    /**
     * BlockTime
     * 封单时间
     * @type {string} 字段类型
     * @memberof LotteryModel
     */
    BlockTime: string = "";                          //封单时间
    HasMorePlayModeType?: number;                   // 0表示只有官方玩法，1表示除了官方玩法外还有信用玩法。
    ID: number = 0;                                 //彩种ID。主键ID
    IsAuto: boolean = false;                            //是否自主开奖
    LotteryCode: string = "";                        //彩种代码
    LotteryName: string = "";                        //彩票编码
    LotteryOpen?: LotteryOpenModel[];           //开奖号码
    LotteryPlayMode?: LotteryPlayMode[];        //彩票玩法类型
    LotteryPlayModeCode: string = "";                //玩法分类编码
    LotteryPlayModeName: string = "";                //玩法分类名称
    LotteryType: string = "";                        //彩票类别代码
    LotteryTypeName: string = "";                    //彩票类型名称
    NumLength: number = 0;                          //数字长度
    OpenLength: number = 0;                         //开奖号码长度
    PlayMode?: LotteryPlayMode;                     //默认玩法类别
    PlayModes?: LotteryPlayMode[];                  //玩法分类
    State: string = "";                             //彩种状态
    SerialsID?: number;                             //排序
    Propertys?: any;                                //
    RewardDown: number = 0;                         //奖金下限
    RewardUp: number = 0;                           //奖金上限
    RecommendSerials?: number;                       //热门彩种排序
    IsRecommend?: boolean;                           //首页热门彩种
    LotteryTypeCodeDisplay?: string;                 // 展示类别code
    LotteryTypeNameDisplay?: string;                 // 展示类别名称

}


/**
 * 开奖号码
 * evan 2018-09-18
 */
export class LotteryOpenModel {
    ID: number = 0;                                  // 开奖管理主键;
    LotteryCode: string = "";                        // 彩票代码。彩种表【Lottery】的外键
    LotteryOpenNo: string = "";                      // 开奖号码
    IssueNo: string = "";                            // 开奖期号
    OpenTime: string = "";                           // 开奖时间
    AddTime: string = "";                            // 开奖号码
    State: string = "";                              // 状态
}

/**
 * 玩法分类
 * evan 2018-09-18
 */
export class LotteryPlayMode {
    ID: number = 0;                                 //主键ID
    LotteryPlayModeCode: string = "";                //彩票玩法代码
    LotteryPlayModeName: string = "";                //彩票玩法名称
    LotteryCode: string = "";                        //彩票代码
    State: string = "";                              //状态
    SerialsID: number = 0;                          //排序
    IsSelect: boolean = false;                          // 是否选中。true：默认选中的玩法
    LotteryTypeCode: string = "";                    //所属的彩种分类编码
    DisableLotteryCodes: string = "";                //
    PlayModeType: number = 0;                       //玩法分类的类型
    LotteryPlayModeTypeCode: number = 0;            //快钱中的LotteryPlayModeTypeCode
    PlayDetails: LotteryPlayDetailModel[];
}


/**
 * 玩法明细
 * evan 2018-09-18
 */
export class LotteryPlayDetailModel {
    ID: number = 0;                                                  //彩票玩法明细主键
    LotteryPlayDetailCode: string = "";                               //玩法明细代码
    LotteryPlayDetailName: string = "";                               //玩法明细名称
    LotteryPlayModeCode: string = "";                                 //彩票玩法代码。玩法分类表【LotteryPlayMode】的外键
    State: string = "";                                               //状态
    SerialsID: number = 0;                                           //排序
    AlgorithmCode: string = "";                                       //算法代码。算法表【Algorithm】的外键
    CardinalMoney: number = 0;                                       //基数金钱
    Modulus: number = 0;                                             //系数
    CardinalMoney1: number = 0;                                      //基数金钱1
    Modulus1: number = 0;                                            //系数1
    LimitBet: number = 0;                                            //限注数
    IsRewardFixed: boolean = false;                                      //是否固定奖金
    IsAttached: string = "";                                          //是否扩展奖金
    PlayGroup: string = "";                                           //玩法明细分组
    DisableLotteryCodes: string = "";                                 //
    Position: string = "";                                            //投注位置
    Algorithm: AlgorithmModel;                                   //对于算法
    PlayDetailAttacheds: PlayDetailAttachedModel[];              //玩法明细附加信息：中奖等级
}


/**
 * 算法明细
 * evan 2018-09-18
 */
export class AlgorithmModel {
    ID: number = 0;                                                     //算法表主键
    AlgorithmCode: string = "";                                         //算法代码
    AlgorithmName: string = "";                                         //算法名称
    SerialsID: number = 0;                                              //排序
    AlgorithmTypeCode: string = "";                                     //算法类别代码
    BetNumLength: number = 0;                                           //投注长度
    TipInfo: string = "";                                                //提示信息
    PickExample: string = "";                                           //序号实例
    AlgorithmType: AlgorithmTypeModel;                                  //算法类别
}


/**
 * 算法类别
 * evan 2018-09-18
 */
export class AlgorithmTypeModel {
    ID: number = 0;                                                   //算法类别主键
    AlgorithmTypeCode: number = 0;                                    //算法类别代码
    AlgorithmTypeName: number = 0;                                    //算法类别名称
    State: number = 0;                                                //状态
    LotteryTypeCode: number = 0;                                      //彩票类别代码
    SerialsID: number = 0;                                            //排序
    PickMode: string = "01";                                          //选号模式
    CanCommonRan: number = 0;                                         //能否常规任选
}


/**
 * 玩法明细附加信息：中奖等级
 * evan 2018-09-18
 */
export class PlayDetailAttachedModel {
    ID: number = 0;
    /**
     * 中奖等级名称
     * @type {string}
     * @memberof PlayDetailAttachedModel
     */
    NumKey: string = "";
    /**
     * 玩法明细表【LotteryPlayDetail】的外键
     * @type {string}
     * @memberof PlayDetailAttachedModel
     */
    LotteryPlayDetailCode: string = "";
    /**
     * 中奖金额
     * @type {number}
     * @memberof PlayDetailAttachedModel
     */
    CardinalMoney: number = 0;
    /**
     * 系数 倍数
     * @type {number}
     * @memberof PlayDetailAttachedModel
     */
    Modulus: number = 0;
    /**
     * 排序ID
     * @type {number}
     * @memberof PlayDetailAttachedModel
     */
    SerialsID: number = 0;
}

export class IssueModel {
    /**
     * 当前期号
     * @type {string}
     * @memberof IssueModel
     */
    CurrentIssueNo: string = "";
    /**
     * 上期期号
     * @type {string}
     * @memberof IssueModel
     */
    PreviewIssueNo: string = "";
    /**
     * 剩余封单时间
     * @type {number}
     * @memberof IssueModel
     */
    RemainTime: number = 0;
    /**
     * 秒
     * @type {number}
     * @memberof IssueModel
     */
    Seconds: number = 0;
    /**
     * 开奖频率即多长时间开奖一次 单位秒
     * @type {number}
     * @memberof IssueModel
     */
    Frequency: number = 0;          //
    /**
     * 期号 -下一期期号信息
     *
     * @type {NextIssueModel}
     * @memberof IssueModel
     */
    Issue: NextIssueModel;
}

export class NextIssueModel {
    IssueNo: string = "";
    BeginTime: string = "";
    EndTime: string = "";
    BeginTime1: string = "";
    EndTime1: string = "";
    LotteryCode: string = "";
    MaxIssue: number = 0;
    MinIssue: number = 0;
    Crossdays: boolean = false;
    LotteryTypeCode: string = "";
    NowIssueDay: string = "";
}

/**
 * 投注选号需要的必要参数 在投注前初始化
 * evan 2018-10-10
 * @export
 * @class BettingMethodParams
 */
export class BettingMethodParams {
    /**
     * 选位配置  如万位，千位，百位，十位，个位等
     * evan 2018-10-10
     * @type {CheckedItemModel[]}
     * @memberof BettingMethodParams
     */
    medianList: CheckedItemModel[] = [];

    /**
     * 玩法选泽 可以投注的号码选择 如0到9的数字，0到11的数字等
     * evan 2018-10-10
     * @type {CheckedItemModel[][]}
     * @memberof BettingMethodParams
     */
    numList: CheckedItemModel[][] = [];

    /**
     * 快捷选中操作命名 大，小，单，双，清 全
     * evan 2018-10-10
     * @type {CheckedItemModel[][]}
     * @memberof BettingMethodParams
     */
    commandList: CheckedItemModel[][] = [];

    /**
     *当前用户选中的位数（万位，千位，百位，十位，个位）集合
     * evan 2018-10-10
     * @type {CheckedItemModel[]}
     * @memberof BettingMethodParams
     */
    checkedList: CheckedItemModel[] = [];


    /**
     * 获取对应的位数，和对应的投注号码 eg：万位：245
     * evan 2018-10-10
     * @type {CheckedItemModel[][]}
     * @memberof BettingMethodParams
     */
    dataSelected: CheckedItemModel[][] = [];

    /**
     * 投注总量 即投多少注数
     * evan 2018-10-10
     * @type {number}
     * @memberof BettingMethodParams
     */
    bettingCount: number = 0;

    /**
     * 是否任选位
     * evan 2018-10-10
     * @type {boolean}
     * @memberof BettingMethodParams
     */
    anyChoose: boolean = false;

    /**
     * 单式投注数据集合
     * evan 2018-11-29
     * @type {string[]}
     * @memberof BettingMethodParams
     */
    bettingNumberArray: string[] = [];

    /**
     * 单式投注数据字符串
     * evan 2018-11-29
     * @type {string}
     * @memberof BettingMethodParams
     */
    bettingNumberString: string = "";

}

export class CheckedItemModel {
    name: string = "";
    checked: boolean = false;
    index: number = -99999;
    place: string = "";
}

/**
 * 投注页面投注信息记录及保存操作
 * evan 2018-10-14
 * @export
 * @class BettingCountModel
 */
export class BettingCountModel {
    dataSelected: CheckedItemModel[][] = [];
    lotteryTypeCode: string = "";
    checkedList: CheckedItemModel[] = [];
    algorithmTypeCode: string = "";
    betNumLength: number = -1;
    anyChoose: boolean = false;
    bettingNumberArray: string[] = [];
    bettingNumberString: string = "";
}

export class ReturnResult {
    Error: string = ""
    Parameter: string = ""
    Result: boolean = false;
}

/**
 * 投注模式实体对象类
 * evan 2018-10-14
 * @export
 * @class MoneyModel
 */
export class MoneyModel {
    id: number = 0;  //默认元模式
    value: number = 1;
    name: string = "";
    checked: boolean = false;
}

/**
 * 投注信息
 *
 * @export
 * @class BettingModel
 */
export class BettingModel {
    ruleName: string = "";
    BettingCount: number = 0;
    multiple: number = 0;
    moneyMode: MoneyModel = null;
    isRewardFixed: boolean = false;
    perBettingPrice: number = 0;
    /**
     * 彩种编码
     */
    LotteryCode: string = "";
    /**
     * 投注期号信息
     */
    IssueNo: string = "";
    /**
     * 玩法明细编码
     */
    LotteryPlayDetailCode: string = "";
    /**
     * 选位
     */
    SelectMedian: string = "";
    /**
     * 投注金额
     */
    BettingMoney: number = 0;
    /**
     *
     */
    GraduationCount: number = 0;
    /**
     * 投注号码
     */
    BettingNumber: string = ""
    /**
     * 是否追号
     */
    IsChaseNo: boolean = false;
    /**
     * 追号期数
     */
    BuyIssueCount: number = 0;
    /**
     * 中奖后是否停止追号
     */
    IsStopAfterWinning: boolean = false;
    /**
     * 投注期号（以及追号期号）
     */
    // BettingInfoIssueList: BettingInfoIssueModel[] = [];
    /**
     * 是否IM投注
     */
    IsImBetting: boolean = false;
    /**
     * 群组编码
     */
    GroupCode: string = ""
}

/**
 *
 *
 * @export
 * @class BettingDataModel
 */
export class BettingDataModel {
    constructor() { }
    playModeType: number = 0;
    bettingList: BettingModel[] = [];
    inputLottery: LotteryModel = new LotteryModel();
    inputPlayModeDetail: LotteryPlayDetailModel = new LotteryPlayDetailModel();
    currIssue: IssueModel = new IssueModel();
    playDetail: LotteryPlayMode = new LotteryPlayMode();
    adjustReward: number = 0;
    rewardUp: number = 0;
    rewardDown: number = 0;
    baseReward: number = 0;
    currUserMoney: number = 0;
    bettingCount: number = 0;
    moneyModel: MoneyModel;
    PerBettingPrice: number = 0;
    Multiple: number = 0;
    RewardPar: number = 0;
}

export class OpenCodeTrend {
    constructor() {
        this.issue = null;
        this.code = [];
        this.open = null;
    }
    issue: string;
    code: any;
    open: string;
}



// WEBPACK FOOTER //
// ./src/models/lottery.model.ts